import React from 'react';
import {
  Paper,
  Box,
  Divider,
  Skeleton
} from '@mui/material';

const BillingSummarySkeleton = ({ 
  elevation = 1,
  showDiscount = true 
}) => {
  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 3,
        mb: 3,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        backgroundColor: 'background.paper'
      }}
    >
      {/* Title Skeleton */}
      <Skeleton 
        variant="text" 
        width="40%" 
        height={28} 
        sx={{ mb: 2, borderRadius: 1 }}
        animation="wave"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Subtotal Row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton 
            variant="text" 
            width="35%" 
            height={22} 
            sx={{ borderRadius: 0.5 }}
            animation="wave"
          />
          <Skeleton 
            variant="text" 
            width="25%" 
            height={22} 
            sx={{ borderRadius: 0.5 }}
            animation="wave"
          />
        </Box>

        {/* Discount Row - Conditionally rendered */}
        {showDiscount && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton 
              variant="text" 
              width="30%" 
              height={22} 
              sx={{ borderRadius: 0.5 }}
              animation="wave"
            />
            <Skeleton 
              variant="text" 
              width="20%" 
              height={22} 
              sx={{ borderRadius: 0.5 }}
              animation="wave"
            />
          </Box>
        )}

        {/* Divider */}
        <Divider sx={{ my: 0.5 }} />

        {/* Grand Total Row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 1 }}>
          <Skeleton 
            variant="text" 
            width="38%" 
            height={26} 
            sx={{ borderRadius: 0.75 }}
            animation="wave"
          />
          <Skeleton 
            variant="text" 
            width="28%" 
            height={30} 
            sx={{ borderRadius: 1 }}
            animation="wave"
          />
        </Box>
      </Box>
    </Paper>
  );
};

export default BillingSummarySkeleton;